module.exports = __webpack_public_path__ + "img/86.ac8fc40e.jpg";